import axios from "axios";

const api = axios.create({
  baseURL:
    process.env.NODE_ENV === "development"
      ? `http://localhost:5006/`
      : `https://kushprakash.com/`,
});

const imageUrl =
  process.env.NODE_ENV === "development"
    ? "http://localhost:5006/images/"
    : "https://kushprakash.com/images/";

const imageUrl2 =
  process.env.NODE_ENV === "development"
    ? "http://localhost:5006/assets/images"
    : "https://kushprakash.com/assets/images";

export default api;
export { imageUrl ,imageUrl2};
